module.exports = __webpack_public_path__ + "img/twilio.3a692503.svg";